import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, User, Briefcase } from 'lucide-react';
import type { NavItem } from '../../types';

const HorizontalNavigation: React.FC = () => {
  const location = useLocation();

  const navItems: NavItem[] = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: Home,
      path: '/',
    },
    {
      id: 'clients',
      label: 'Clients',
      icon: User,
      path: '/clients',
    },
    {
      id: 'matters',
      label: 'Matters',
      icon: Briefcase,
      path: '/matters',
    },
  ];

  const isActiveRoute = (path: string) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };

  return (
    <nav className="bg-gray-800 border-b border-gray-700 shadow-sm hidden md:block">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex space-x-8">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = isActiveRoute(item.path);
            
            return (
              <Link
                key={item.id}
                to={item.path}
                className={`inline-flex items-center space-x-2 px-4 py-4 border-b-2 font-medium text-sm transition-colors ${
                  isActive
                    ? 'border-blue-500 text-blue-400'
                    : 'border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-500'
                }`}
                data-testid={`nav-${item.id}`}
              >
                <Icon className="w-4 h-4" />
                <span>{item.label}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default HorizontalNavigation;
